"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_bootstrap_icons_1 = require("react-bootstrap-icons");
const react_redux_1 = require("react-redux");
const family_svg_1 = __importDefault(require("../../../assets/images/family.svg"));
const propertyBackDefault_webp_1 = __importDefault(require("../../../assets/images/propertyBackDefault.webp"));
const room_webp_1 = __importDefault(require("../../../assets/images/room.webp"));
const modal_1 = __importDefault(require("../../../components/modal"));
const Properties_1 = require("../../../hooks/Properties");
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
const helpers_1 = require("../../../utils/helpers");
require("./BookBanner.scss");
const DescriptionModal_1 = __importDefault(require("./descriptionModal/DescriptionModal"));
const GalleryImages_1 = __importDefault(require("./galleryImages/GalleryImages"));
const MINIMUM_TO_SHOW_BANNER = 1;
const BookBanner = ({ title, location, address, discourse, rating, properties }) => {
    var _a, _b, _c, _d, _e, _f;
    const building = (0, react_redux_1.useSelector)((state) => state.suitesReserve.building);
    const [suiteData, setSuiteData] = (0, react_1.useState)();
    const [modalOpened, setModalOpened] = (0, react_1.useState)('default');
    // const [ratingStars, setRatingStars] = useState<Array<JSX.Element>>([]);
    const [imageIsLoading, setImageIsLoading] = (0, react_1.useState)(true);
    const [localDescription, setLocalDescription] = (0, react_1.useState)(discourse);
    const modalRef = (0, react_1.useRef)(null);
    const propContext = (0, Properties_1.useProperties)();
    const [modalRules, setModalRules] = (0, react_1.useState)();
    const { isMobile } = (0, detectDevice_1.default)(993);
    const isSafari = (0, helpers_1.isBrowserSafari)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (properties.length === MINIMUM_TO_SHOW_BANNER) {
            const suiteTemp = (_a = propContext.properties) === null || _a === void 0 ? void 0 : _a.find(prop => prop.propId.toString() === properties[0]);
            if ((suiteTemp === null || suiteTemp === void 0 ? void 0 : suiteTemp.texts) && (suiteTemp === null || suiteTemp === void 0 ? void 0 : suiteTemp.texts.length) > 0) {
                setLocalDescription(suiteTemp === null || suiteTemp === void 0 ? void 0 : suiteTemp.texts[0].locationDescription);
            }
            setSuiteData(suiteTemp);
        }
        else if ((properties.length > MINIMUM_TO_SHOW_BANNER && building.showThis) || properties.length === 0) {
            const suiteTemp = (_b = propContext.properties) === null || _b === void 0 ? void 0 : _b.find(prop => prop.propId.toString() === building.showThis);
            if ((suiteTemp === null || suiteTemp === void 0 ? void 0 : suiteTemp.texts) && (suiteTemp === null || suiteTemp === void 0 ? void 0 : suiteTemp.texts.length) > 0) {
                setLocalDescription(suiteTemp === null || suiteTemp === void 0 ? void 0 : suiteTemp.texts[0].locationDescription);
            }
            setSuiteData(suiteTemp);
        }
    }, [building, properties, propContext.properties]);
    const handleOpenModal = (0, react_1.useCallback)((modal) => {
        setModalOpened(modal);
    }, []);
    const closeModal = (0, react_1.useCallback)(() => {
        setModalOpened('default');
    }, []);
    const handleOpenModalRules = (0, react_1.useCallback)((modal) => {
        setModalRules(modal);
    }, []);
    const closeModalRules = (0, react_1.useCallback)(() => {
        setModalRules(undefined);
    }, []);
    const calculateRating = (0, react_1.useCallback)((action = 'weighAverage') => {
        if (rating) {
            const weigh = Object.keys(rating)
                .map(el => +el)
                .reduce((_, next) => rating[next] * next);
            const sums = Object.values(rating).reduce((sum, value) => sum + value);
            if (action === 'onlySum') {
                return sums;
            }
            return weigh / sums;
        }
        return 0;
    }, [rating]);
    (0, react_1.useEffect)(() => {
        const calculatedRating = calculateRating();
        const isInteger = calculatedRating % 2 === 0;
        const integer = Math.floor(calculatedRating);
        const stars = [];
        new Array(integer)
            .fill(0)
            .map((elem, idx) => stars.push(react_1.default.createElement(react_bootstrap_icons_1.StarFill, { key: `fill_${elem + idx}`, size: isMobile ? 18 : 25, fill: "#f6cf0a" })));
        if (!isInteger) {
            stars.push(react_1.default.createElement(react_bootstrap_icons_1.StarHalf, { key: "half_0", size: isMobile ? 18 : 25, fill: "#f6cf0a" }));
        }
        while (stars.length < 5) {
            stars.push(react_1.default.createElement(react_bootstrap_icons_1.Star, { key: `empty_${5 - stars.length}`, size: isMobile ? 18 : 25, fill: "#f6cf0a" }));
        }
        // setRatingStars(stars);
    }, []);
    (0, react_1.useEffect)(() => {
        window.scrollTo(0, 0);
    }, []);
    const modalContent = (0, react_1.useCallback)(() => {
        const content = {
            galleryModal: (react_1.default.createElement(modal_1.default, { ref: modalRef, open: !!modalOpened },
                react_1.default.createElement(GalleryImages_1.default, { title: (suiteData === null || suiteData === void 0 ? void 0 : suiteData.name) || '', close: closeModal, imagesList: suiteData === null || suiteData === void 0 ? void 0 : suiteData.images }))),
            moreInfos: (react_1.default.createElement(modal_1.default, { ref: modalRef, open: !!modalOpened },
                react_1.default.createElement(DescriptionModal_1.default, { close: closeModal, title: (suiteData === null || suiteData === void 0 ? void 0 : suiteData.name) || '' }))),
        };
        return content[modalOpened] || null;
    }, [closeModal, modalOpened, suiteData]);
    const modalCondominiumRules = (0, react_1.useCallback)(() => {
        return (react_1.default.createElement(modal_1.default, { ref: modalRef, open: !!modalRules },
            react_1.default.createElement(DescriptionModal_1.default, { close: closeModalRules, title: suiteData === null || suiteData === void 0 ? void 0 : suiteData.name, descriptionFull: suiteData && suiteData.texts ? suiteData === null || suiteData === void 0 ? void 0 : suiteData.texts[0].propertyDescription1 : '', textRules: "Regras do condom\u00EDnio" })));
    }, [closeModalRules, modalRules, suiteData]);
    const showBanner = (0, react_1.useCallback)(() => {
        if (!!building.showThis || properties.length === MINIMUM_TO_SHOW_BANNER) {
            return false;
        }
        return true;
    }, [building.showThis, properties.length]);
    const imageLoaded = (0, react_1.useCallback)(() => {
        setImageIsLoading(false);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "BookBanner", hidden: showBanner() },
            react_1.default.createElement("div", { className: "BannerContent" },
                react_1.default.createElement("div", { className: "imagesRow", style: { height: isSafari ? '32vh' : '65%' } },
                    react_1.default.createElement("div", { className: "gradient" },
                        react_1.default.createElement("div", { className: "loadingMain", style: { display: imageIsLoading ? 'flex' : 'none' } },
                            react_1.default.createElement(antd_1.Spin, { size: "large" })),
                        react_1.default.createElement("img", { src: ((_b = (_a = suiteData === null || suiteData === void 0 ? void 0 : suiteData.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url) || propertyBackDefault_webp_1.default, loading: "eager", alt: "", onLoad: imageLoaded, style: { display: imageIsLoading ? 'none' : 'block' } }),
                        react_1.default.createElement("div", { className: "name" },
                            "Edif\u00EDcio \u00A0",
                            react_1.default.createElement("span", null, suiteData === null || suiteData === void 0 ? void 0 : suiteData.name)),
                        react_1.default.createElement("div", { id: "galleryModal", onClick: () => handleOpenModal('galleryModal'), onKeyDown: event => {
                                if (event.code === '13') {
                                    handleOpenModal('galleryModal');
                                }
                            }, "aria-hidden": "true" }, "Todas as fotos")),
                    !isMobile && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "loadingSec", style: { display: imageIsLoading ? 'flex' : 'none' } },
                            react_1.default.createElement(antd_1.Spin, { size: "large" })),
                        react_1.default.createElement("div", { className: "loadingSec", style: { display: imageIsLoading ? 'flex' : 'none' } },
                            react_1.default.createElement(antd_1.Spin, { size: "large" })),
                        react_1.default.createElement("img", { src: ((_d = (_c = suiteData === null || suiteData === void 0 ? void 0 : suiteData.images) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.url) || propertyBackDefault_webp_1.default, alt: "", style: { display: imageIsLoading ? 'none' : 'block' } }),
                        react_1.default.createElement("img", { src: ((_f = (_e = suiteData === null || suiteData === void 0 ? void 0 : suiteData.images) === null || _e === void 0 ? void 0 : _e[2]) === null || _f === void 0 ? void 0 : _f.url) || propertyBackDefault_webp_1.default, alt: "", style: { display: imageIsLoading ? 'none' : 'block' } })))),
                react_1.default.createElement("div", { className: "informationsRow" },
                    react_1.default.createElement("div", { className: "leftContent" },
                        react_1.default.createElement("span", null, (suiteData === null || suiteData === void 0 ? void 0 : suiteData.name) || title),
                        react_1.default.createElement("span", null, `${(suiteData === null || suiteData === void 0 ? void 0 : suiteData.city) || location}`),
                        react_1.default.createElement("span", null, (suiteData === null || suiteData === void 0 ? void 0 : suiteData.address) || address)),
                    react_1.default.createElement("div", { className: "rightContent" },
                        react_1.default.createElement("span", null, localDescription))),
                react_1.default.createElement("div", { className: "actionsRow" },
                    react_1.default.createElement("div", { className: "endContent" },
                        react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement("span", { onClick: () => handleOpenModalRules('condominiumRules'), onKeyDown: event => {
                                    if (event.code === '13') {
                                        handleOpenModalRules('condominiumRules');
                                    }
                                } }, "Regras de condom\u00EDnio")))))),
        modalOpened && modalContent(),
        modalRules && modalCondominiumRules()));
};
BookBanner.defaultProps = {
    mainImage: 'https://360suites.com.br/wp-content/uploads/2020/07/360-Luz.webp',
    secondImage: family_svg_1.default,
    thirdImage: room_webp_1.default,
    title: 'Sem dados',
    location: 'Sem dados',
    address: 'Sem dados',
    discourse: 'No momento estamos sem informações à respeito do edifício selecionado.',
    rating: {
        1: 0,
        2: 0,
        3: 10,
        4: 2000,
        5: 2437,
    },
};
exports.default = BookBanner;
